// extracted by mini-css-extract-plugin
export default {"root":"InfoModal_root__Ul7oU","before":"InfoModal_before__4YPCR","label":"InfoModal_label__Px8gJ"};